import {createStore} from 'redux';
import CombinedReducer from 'app/stores/Reducer';
import {composeWithDevTools as ComposeWithDevTools} from 'redux-devtools-extension';

export const Store = createStore(CombinedReducer, ComposeWithDevTools());
